import {
    OPERATOR_STATUS_INVISIBLE,
    OPERATOR_STATUS_OFFLINE,
    OPERATOR_STATUS_ONLINE,
    OperatorStatus
} from "~/chat/ts/data/OperatorStatus";
import {__} from "~/ts/library/Translate";
import ObjectHelper from "~/ts/library/ObjectHelper";

export interface OperatorStatusInterface {
    statusId: OperatorStatus,
    descr: string,
    colorClassName: string
}

export function getOperatorStatusList(): OperatorStatusInterface[] {
    return [
        {
            statusId: OPERATOR_STATUS_ONLINE,
            descr: __("в сети"),
            colorClassName: 'status-1'
        },
        {
            statusId: OPERATOR_STATUS_OFFLINE,
            descr: __("отошёл"),
            colorClassName: 'orange'
        },
        {
            statusId: OPERATOR_STATUS_INVISIBLE,
            descr: __("невидимый"),
            colorClassName: 'status--1'
        }
    ];
}

export function getOperatorStatusDictionary() {
    return ObjectHelper.dictionaryFromArray(getOperatorStatusList(), 'statusId');
}